import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: 'img[appImgFallback]',
  standalone: true
})
export class ImgFallbackDirective {
  @Input() appImageFallback: string | null = null;
  private defaultImageFallbackSrc = 'assets/images/fallback-image.svg'

  constructor(private elRef: ElementRef) { }

  @HostListener('error') loadFallbackImageOnError() {
    const currentImageElement: HTMLImageElement = this.elRef.nativeElement as HTMLImageElement;
    currentImageElement.src = this.appImageFallback || this.defaultImageFallbackSrc;
  }
}
